export enum PayoutTransactionStatus {
  NOT_PROCESSED = 'not_processed',
  PROCESSING = 'processing',
  SENT = 'sent',
  FROZEN = 'frozen',
  ERROR = 'error',
  REQUIRE_MANUAL_ACTION = 'require_manual_action',
}
